import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

/**
 * Display a Select for events
 * @param eventList : list of events (raw object)
 * @param onSelect : func to do action on select event
 * @param  eventSelected: event id selected
 */
export default function EventSelector({ eventList, resaleMode, onSelect, configExceptions = [], eventSelected = null }) {
    const { t } = useTranslation();
    // let [list, setList] = React.useState([]);
    const list = React.useMemo(() => {
        let excepted_events = configExceptions.filter(config => config.enabled !== resaleMode).reduce((events, config) => events.add(config.event), new Set());
        return eventList
            .filter(event => {
                if (event.id === eventSelected) {
                    return true;
                }
                return !excepted_events.has(event.id);
            })
            .map(event => {
                return {
                    key: event.id,
                    value: event.id,
                    text: event.name
                };
            });
    }, [eventList, eventSelected, resaleMode]);

    return (
        <Select
            search
            fluid
            className={'event-selector-select-button'}
            placeholder={t('ticket.resales.config.event_selector_placeholder')}
            value={eventSelected}
            options={list}
            onChange={(e, { value }) => {
                onSelect(value);
            }}
        />
    );
}

EventSelector.propTypes = {
    eventList: PropTypes.array.isRequired,
    configExceptions: PropTypes.array.isRequired,
    resaleMode: PropTypes.bool.isRequired,
    onSelect: PropTypes.func.isRequired,
    eventSelected: PropTypes.number
};
